import { gql } from "apollo-boost"

export const GET_SUSTAINABILITY_DETAILS = gql`
  query getSustainabilityDetailsBySubmissionID($id: String!) {
    SustainabilityDetails(submissionId: $id) {
      id
      hasOwnIncome
      hasIncreasedOwnIncome
      strategyOfProcurement
      hasStrategyOfProcurement    
      hasResourcesOutsideFicosec
      institucionalResponsePotential
      hasInstitucionalResponsePotential
      participantsMustPayFee
      paymentJustification
      paymentAmount
      isRecurringPayment
      recurringPaymentFrequency
      sustainabilityIsBlocking
      riskManagementIsBlocking
      submission{
        status
        state
      }
      riskManagements {
        isBlocking
        id
        name
        riskProbability
        riskImpactOnTheProject
        riskManagementDescription
        riskHasOccurred
        hasAppliedActionProcess        
        commentsDescription
      }
    }
  }
`
